import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    gridContainer: {
        [theme.breakpoints.up('sm')]: {},
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'column',
        minWidth: '312px',
        position: 'relative',
    },
    loaderContainer: {
        top: '0',
        position: 'absolute',
        left: '0',
        width: '100%',
        zIndex: '99999999999999999999',
        background: '#f8f8f8',
        opacity: '.8',
        height: '100vh',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            height: '100%',
        },
    },
}));
